import React from "react";
import { passesServices } from "services/passes/passes.services";
import { passesConstants } from "constants/passes/passes.constant";
import { checkUserActivityFromStorage } from "helpers/common";

export const passesActions = {
    getGenerealSetting,
    getPlaceDetailBasedOnPlaceId,
    getEnigmaUrlValue,
    getFilterizePlaceDetail,
    getCartDetail,
    createOrder,
    deleteDocFromEnigma,
    writeErroLogToServer,
    checkUserActive
}

// get general settting
function getGenerealSetting() {
    return dispatch => {
        dispatch(updateData(null));
        passesServices.getGeneralSetting().then(
            (data: any) => {
                dispatch(updateData(data));
            },
            error => {
                dispatch(updateData(null))
            }
        );
    }

    function updateData(settingDetail) {
        return { type: passesConstants.GET_GENERAL_SETTINGS, settingDetail }
    }
}

// get place detail based on place id
function getPlaceDetailBasedOnPlaceId(placeId: any) {
    return dispatch => {
        dispatch(updateData(null));
        passesServices.getPlaceDetailBasedOnPlaceId(placeId).then(
            (data: any) => {
                dispatch(updateData(data));
            },
            error => {
                dispatch(updateData(null))
            }
        );
    }

    function updateData(placeDetail) {
        return { type: passesConstants.GET_PLACE_DETAIL_BASED_ON_ID, placeDetail }
    }
}

// get enigma url value
function getEnigmaUrlValue(fileType, contents, callback) {
    passesServices.getEnigmaFileUrl(fileType, contents)
        .then(
            data => {
                if (data.status === 200) {
                    passesServices.uploadFileToEnigma(data.data?.url, fileType, contents);
                    callback(data.data?.fileName);
                } else {
                    // dispatch(loaderActions.hide());
                    // dispatch(alertActions.error(data.Message));
                    // dispatch(alertActions.clear());
                }
            },
            error => {
                // dispatch(loaderActions.hide());
                // dispatch(alertActions.error(error));
                // dispatch(alertActions.clear());
            }
        );
}

// get filterize place detail
function getFilterizePlaceDetail(placeRequestDetail: any) {
    return dispatch => {
        dispatch(updateData(null));
        passesServices.getPlaceDetailBasedOnFilterizeValue(placeRequestDetail, false).then(
            (data: any) => {
                dispatch(updateData(data));
            },
            error => {
                dispatch(updateData(null))
            }
        );
    }

    function updateData(placeDetail) {
        return { type: passesConstants.GET_PLACE_DETAIL_BASED_ON_ID, placeDetail }
    }
}

// get cart detail
function getCartDetail() {
    return dispatch => {
        checkUserActivityFromStorage();
        // dispatch(updateData(null));
        passesServices.getCartDetail().then(
            (data: any) => {
                dispatch(updateData(data));
            },
            error => {
                dispatch(updateData(null))
            }
        );
    }

    function updateData(cartDetail) {
        return { type: passesConstants.GET_CART_DETAIL, cartDetail }
    }
}

// create order
function createOrder(paymentCardId, squarePaymentToken){
    return dispatch => {
        dispatch(updateData(null));
        passesServices.createOrder(paymentCardId, squarePaymentToken).then(
            (data: any) => {
                dispatch(updateData(data));
            },
            error => {
                dispatch(updateData(null))
            }
        );
    }

    function updateData(orderDetail){
        return {type: passesConstants.GET_CREATED_ORDER_DETAIL, orderDetail}
    }
}

// delete document from Enigma
function deleteDocFromEnigma(docList){
    return dispatch => {
        passesServices.deleteDocFromEnigma(docList).then(
            (data: any) => {
                // dispatch(updateData(data));
            },
            error => {
                // dispatch(updateData(null))
            }
        );
    }
}

// daily user-active ping (fire and forget)
function checkUserActive() {
    return dispatch => {
        passesServices.checkUserActive().then(
            (data: any) => {
                if(data === true){
                    dispatch(updateData());
                }
            },
            error => {
            }
        );
    }

    function updateData(){
        return {type: passesConstants.IS_USER_DELETED_AND_LOGOUT, isUserDeletedAndLogout: true}
    }
}

// get cart detail
function writeErroLogToServer(logData) {
    return dispatch => {
        passesServices.postLog(logData).then(
            (data: any) => {
            },
            error => {
            }
        );
    }
}
